import { OPTIONS_INTEGRATION } from 'app-constants'
import { http } from 'hooks'

export function addressService() {
  function getCondominiums(params) {
    const optionsWithParams = { ...OPTIONS_INTEGRATION, params }

    return http.get(`/v1/addresses/condominiums`, optionsWithParams)
  }

  function getCondominiumViability(params) {
    const optionsWithParams = { ...OPTIONS_INTEGRATION, params }

    return http.get('/v1/addresses/check-condominium-viability', optionsWithParams)
  }

  function validateZipCode(data) {
    return http.get(`v1/addresses/validate-zip-code?zipCode=${data}`, OPTIONS_INTEGRATION)
  }

  function getHouseViability(params) {
    const withParams = {
      ...OPTIONS_INTEGRATION,
      params,
    }
    return http.get(`/v1/addresses/check-house-viability`, withParams)
  }

  return {
    getCondominiums,
    getCondominiumViability,
    validateZipCode,
    getHouseViability,
  }
}
